<template>
    <div class="sub-page">
        <div class="btn-close"><Icon type="ios-close-circle-outline" @click="cancel" /></div>
        <div class="sub-page-bd">
            <Form ref="form" :model="formData" :rules="rule" :label-width="150">
                <FormItem :label="$t('cname')">
                    <Input v-model="org_cname" disabled></Input>
                </FormItem>
                <Row>
                    <Col span="12">
                        <FormItem :label="$t('hc_amt')" prop="hc_amt">
                            <Input v-model="formData.hc_amt">
                                <span slot="append">{{$t('price_unit')}}</span>
                            </Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem>
                            <Checkbox v-model="formData.jb_show_diff" true-value="1" false-value="0">{{$t('jb_show_diff')}}</Checkbox>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="12">
                        <FormItem :label="$t('select_lang')">
                            <Select v-model="formData.locale" :placeholder="$t('select')">
                                <Option :value="item.key" v-for="(item, index) in $config.langs" :key="index">{{item.val}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12" v-if="org_level == 3">
                        <FormItem :label="$t('show_day_qty')" prop="show_day_qty">
                            <Input v-model="formData.show_day_qty">
                                <span slot="append">{{$t('day')}}</span>
                            </Input>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="12">
                        <FormItem :label="$t('order_remark1')">
                            <Input v-model="formData.order_remark1" type="textarea" :autosize="{minRows: 7,maxRows: 10}" :placeholder="$t('input')"></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem :label="$t('order_remark2')">
                            <Input v-model="formData.order_remark2" type="textarea" :autosize="{minRows: 7,maxRows: 10}" :placeholder="$t('input')"></Input>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="12"><FormItem :label="$t('add_user')"><Input v-model="formData.add_user" disabled></Input></FormItem></Col>
                    <Col span="12"><FormItem :label="$t('add_time')"><Input v-model="formData.add_time" disabled></Input></FormItem></Col>
                </Row>
                <Row>
                    <Col span="12"><FormItem :label="$t('upd_user')"><Input v-model="formData.upd_user" disabled></Input></FormItem></Col>
                    <Col span="12"><FormItem :label="$t('upd_time')"><Input v-model="formData.upd_time" disabled></Input></FormItem></Col>
                </Row>
            </Form>
        </div>
        <div class="sub-page-ft">
            <Button style="margin-right: 8px" @click="cancel">{{$t('cancel')}}</Button>
            <Button type="primary" @click="submit">{{$t('save')}}</Button>
        </div>
    </div>
</template>

<script>
    export default {
        data:function(){
            return{
                relist: false,
                org_cname: '',
                org_level: '',
                formData: {
                    org_id:'',
                    jb_show_diff: '0', // 交班时显示应收
                    jh_coin_qty:'', //借卡押金
                    jh_fee_amt:'', // 预存款借卡
                    hc_amt: '', // 换卡费用
                    fee_price: '',       //  预存款基础价值(元)',
                    coin_price: '',  //  代币基础价值(元)',
                    back_fee_price: '',       //  退预存款价值(元)',
                    back_coin_price: '',  //  退代币价值(元)',
                    coin_last_date: '', // 代币有效期至
                    pticket_last_date: '', // 奖票有效期至
                    ac_last_date: '', // 积分有效期至
                    locale: '', // 选择语言
                    order_remark1: '', // 商品销售规则
                    order_remark2: '', // 礼品兑换规则
                    show_day_qty:'', //显示多少天数据
                    add_user:'',
                    add_time:'',
                    upd_user:'',
                    upd_time:'',
                },
                rule: {
                    fee_price: [{required: true, pattern:this.$base.regNum(), message: this.$t('input'), trigger: 'blur'}],
                    coin_price: [{required: true, pattern:this.$base.regNum(), message: this.$t('input'), trigger: 'blur'}],
                    back_fee_price: [{required: true, pattern:this.$base.regNum(), message: this.$t('input'), trigger: 'blur'}],
                    back_coin_price: [{required: true, pattern:this.$base.regNum(), message: this.$t('input'), trigger: 'blur'}],
                    jh_coin_qty: [{required: true, pattern:this.$base.regNum(), message: this.$t('input'), trigger: 'blur'}],
                    jh_fee_amt: [{required: true, pattern:this.$base.regNum(), message: this.$t('input'), trigger: 'blur'}],
                    hc_amt: [{required: true, pattern:this.$base.regNum(), message: this.$t('input'), trigger: 'blur'}],
                },
                item: {}
            }
        },
        mounted: function(){
            this.$parent.$parent.show_subview = true;
            this.formData.org_id = this.$base.getRequest().org_id;
            this.item = JSON.parse(this.$base.getRequest().data);
            this.getInfo();
        },
        methods:{
            cancel: function(){
                this.$base.linkBack();
            },
            getInfo: function(){
                var org_id = this.$base.getRequest().org_id;
                if(!org_id){
                    return;
                }
                this.$base.showLoading();
                this.$request.sendPost("org-down-s1/before-setup",{org_id},(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.formData = this.$base.leftJson(this.formData,data.setup_info);
                        this.org_cname = `${this.item.org_cname}`;
                        this.org_level = this.item.org_level;
                        this.formData.coin_last_date = this.formData.coin_last_date? this.$moment.unix(this.formData.coin_last_date)._d : '';
                        this.formData.pticket_last_date = this.formData.pticket_last_date? this.$moment.unix(this.formData.pticket_last_date)._d : '';
                        this.formData.ac_last_date = this.formData.ac_last_date? this.$moment.unix(this.formData.ac_last_date)._d : '';
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            submit: function(){
                var url = 'org-down-s1/setup';
                this.$refs["form"].validate((valid) => {
                    if (valid) {
                        this.formData.coin_last_date = this.formData.coin_last_date ? this.$moment(this.formData.coin_last_date).format('YYYY-MM-DD') : '';
                        this.formData.pticket_last_date = this.formData.pticket_last_date ? this.$moment(this.formData.pticket_last_date).format('YYYY-MM-DD') : '';
                        this.formData.ac_last_date = this.formData.ac_last_date ? this.$moment(this.formData.ac_last_date).format('YYYY-MM-DD') : '';
                        this.$base.showLoading();
                        this.$request.sendPost(url,this.formData,(success,data,error)=>{
                            this.$base.hideLoading();
                            if(success){
                                this.$base.alertSuccess(error.errmsg);
                                this.relist = true;
                                this.$base.linkBack();
                            }
                            else{
                                this.$base.alertErr(error.errmsg);
                            }
                        });
                    } else {
                        this.$base.alertErr(this.$t('incomplete'));
                    }
                })

            }
        },
        beforeDestroy: function () {
            this.$parent.$parent.show_subview = false;
            this.$parent.$parent.relist = this.relist;
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/org/down/downs1_setup.vue